import {
  pattern2
} from "./index-cb77qg3g.mjs";
export {
  pattern2 as pattern
};
